import { useState, useEffect, useContext, useMemo } from 'react';
import { Col, Button, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import Loader from '../../../layouts/loader/Loader';
import Desplegable from './Desplegable';
import { AuthContext } from '../../../context/authContext';
import matriculacionApiService from '../../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../../services/storage';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';

const ActividadesGrupos = (props) => {
  // Preparamos variables necesarias

  const soloLectura = useSoloLecturaMatriculas();
  const [isAllCheked, setIsAllCheked] = useState(false);
  const enrollmentSession = getItem(STORAGE_KEYS.ENROLLMENT);
  const [dataPrecio, setDataPrecio] = useState([]);
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(props.sumatorio);
  const [totalSuelto, setTotalSuelto] = useState(props.sumatorioSuelto);
  const [total2, setTotal2] = useState(props.sumatorio2);
  const [totalSuelto2, setTotalSuelto2] = useState(props.sumatorioSuelto2);
  const localEnrollment = getItem(STORAGE_KEYS.ENROLLMENT);
  const { userOU } = useContext(AuthContext);

  const precioFinal = useMemo(() => {
    if (props.allFirstYearChecked && props.allSecondYearChecked) {
      return total + total2;
    }
    if (!props.allFirstYearChecked && props.allSecondYearChecked) {
      return totalSuelto + total2;
    }
    if (props.allFirstYearChecked && !props.allSecondYearChecked) {
      return total + totalSuelto2;
    }
    return totalSuelto + totalSuelto2;
  }, [props.allFirstYearChecked, props.allSecondYearChecked, total, total2, totalSuelto, totalSuelto2]);

  useEffect(() => {
    props.setPrecioFinal(precioFinal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [precioFinal]);

  // Pre-marcado: cuando ya tenemos activity y dataApi, calculamos los módulos
  // ya matriculados, sus horas y totales, sin esperar a que el usuario expanda
  // ningún Desplegable. No marca dirty: es estado inicial, no una edición.
  useEffect(() => {
    if (Object.keys(props.activity).length === 0 || dataApi.length === 0) return;
    if (props.modulos.length > 0) return;

    const matched = [];
    let hours = 0;
    let sumTot = 0;
    let sumTotSuelto = 0;
    let sumTot2 = 0;
    let sumTotSuelto2 = 0;

    Object.entries(props.activity).forEach(([, array]) => {
      array.forEach((obj) => {
        if (!dataApi.some((d) => d.descripcion === obj.descripcion)) return;
        const value = `${obj.modulo} ${obj.descripcion}`;
        matched.push(value);
        if (
          !obj.descripcion.includes('Formación en el centro de trabajo') &&
          !obj.descripcion.includes('Formación en centros de trabajo')
        ) {
          hours += parseInt(obj.horas != null ? obj.horas.toString() : '0', 10);
        }
        if (obj.curso === 'PRIMERO') {
          sumTot += obj.precio;
          sumTotSuelto += obj.importe_suelto;
        } else {
          sumTot2 += obj.precio;
          sumTotSuelto2 += obj.importe_suelto;
        }
      });
    });

    if (matched.length === 0) return;

    props.setModulos(matched);
    props.setHoursCounter(hours);
    setTotal(sumTot);
    setTotal2(sumTot2);
    setTotalSuelto(sumTotSuelto);
    setTotalSuelto2(sumTotSuelto2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activity, dataApi]);

  // Efectos
  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataObtenerTotal = await matriculacionApiService.obtenerTotal({
          headquarter: localEnrollment.headquarter,
          id: enrollmentSession.id,
        });
        props.setHoursCounter(dataObtenerTotal[0].horas);
        setTotal(dataObtenerTotal[1].importe);
        setTotal2(dataObtenerTotal[2].importe);
        setTotalSuelto2(dataObtenerTotal[2].importe_suelto);
        setTotalSuelto(dataObtenerTotal[1].importe_suelto);
      } catch (error) {
        props.setHoursCounter(0);
        setTotal(props.sumatorio);
        setTotalSuelto(props.sumatorioSuelto);
        setTotalSuelto2(props.sumatorioSuelto2);
        setTotal2(props.sumatorio2);
      }

      try {
        const dataDetalleMatricula = await matriculacionApiService.detalleMatricula({
          headquarter: enrollmentSession.headquarter,
          id: enrollmentSession.id,
        });
        setDataApi(dataDetalleMatricula);
      } catch (error) {
        setDataApi([]);
      }

      try {
        const dataPreciosCiclo = await matriculacionApiService.buscarPreciosCiclo({
          headquarter: localEnrollment.headquarter,
          groupId: props.id,
          id: props.ccodcli,
        });
        setDataPrecio(dataPreciosCiclo);
      } catch (error) {
        setDataPrecio([]);
      }

      try {
        const dataModulos = await matriculacionApiService.buscarModulos({
          headquarter: localEnrollment.headquarter,
          enrollmentId: props.idMatricula,
        });
        props.setActivity(dataModulos);
      } catch (error) {
        props.setActivity([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Función para seleccionar todos los módulos
  const marcarTodos = () => {
    if (props.markModulosDirty) props.markModulosDirty();
    let hours = 0;
    let sumTot = 0;
    let sumTotSuelto = 0;
    let sumTot2 = 0;
    let sumTotSuelto2 = 0;
    Object.entries(props.activity).forEach(([, array]) => {
      array.forEach((obj) => {
        const value = `${obj.modulo} ${obj.descripcion}`;

        if (!props.modulos.includes(value) && obj.Nota !== 1) {
          const newArr = props.modulos;
          newArr.push(value);
          props.setModulos([...newArr]);

          if (obj.curso === 'PRIMERO') {
            sumTot += obj.precio;
            sumTotSuelto += obj.importe_suelto;
          } else {
            sumTot2 += obj.precio;
            sumTotSuelto2 += obj.importe_suelto;
          }

          if (
            !obj.descripcion.includes('Formación en el centro de trabajo') &&
            !obj.descripcion.includes('Formación en centros de trabajo')
          ) {
            const notaAsInt = parseInt(obj.horas !== null ? obj.horas.toString() : '0', 10);
            hours += notaAsInt;
          }
        }
      });
    });

    setIsAllCheked(true);
    props.setHoursCounter(hours);
    setTotal(sumTot);
    setTotal2(sumTot2);
    setTotalSuelto(sumTotSuelto);
    setTotalSuelto2(sumTotSuelto2);
  };

  // Función para desmarcar todos los módulos
  const desmarcarTodos = () => {
    if (props.markModulosDirty) props.markModulosDirty();
    const newArr = [];
    props.setModulos(newArr);

    setIsAllCheked(false);
    props.setHoursCounter(0);
    setTotal(0);
    setTotal2(0);
    setTotalSuelto2(0);
    setTotalSuelto(0);
  };

  return (
    <>
      <Row>
        <Col sm="7">
          <h4>Actividades</h4>
        </Col>
      </Row>
      {Object.keys(props.activity).length === 0 && dataPrecio.length === 0 ? (
        <Loader />
      ) : (
        <>
          <Row>
            {userOU.centro === 'ORIENTACIÓN' ? (
              ''
            ) : (
              <Col md="10">
                {isAllCheked ? (
                  <Button className="me-1 mb-2" onClick={desmarcarTodos} disabled={!!props.estado || soloLectura}>
                    <i className="bi bi-check-square" style={{ marginRight: '8px' }}></i>
                    Desmarcar todos
                  </Button>
                ) : (
                  <Button className="me-1 mb-2" onClick={marcarTodos} disabled={!!props.estado || soloLectura}>
                    <i className="bi bi-check-square-fill" style={{ marginRight: '8px' }}></i>
                    Marcar todos
                  </Button>
                )}
              </Col>
            )}
          </Row>

          <div style={{ marginTop: '8px' }}>
            {Object.entries(props.activity).map(([key, array]) => (
              <Desplegable
                key={key}
                array={array}
                activity={props.activity}
                keyArray={key}
                modulos={props.modulos}
                estado={props.estado}
                setModulos={props.setModulos}
                markModulosDirty={props.markModulosDirty}
                setHoursCounter={props.setHoursCounter}
                setTotal={setTotal}
                setTotalSuelto={setTotalSuelto}
                total={total}
                totalSuelto={totalSuelto}
                setTotal2={setTotal2}
                setTotalSuelto2={setTotalSuelto2}
                total2={total2}
                totalSuelto2={totalSuelto2}
                hoursCounter={props.hoursCounter}
                idMatricula={props.idMatricula}
                dataApi={dataApi}
                setActivity={props.setActivity}
              />
            ))}
          </div>
        </>
      )}
      <Row>
        <Col>
          <b>Horas {props.hoursCounter} </b>
          <b>Precio total {precioFinal} € </b>
        </Col>
      </Row>
      <Row>
        {props.isNoPresencial && props.hoursCounter > 2000 ? (
          <small className="text-danger">
            Ha superado el máximo de horas disponibles. (2000h sin contar FCT)
          </small>
        ) : (
          ''
        )}
      </Row>
    </>
  );
};

ActividadesGrupos.propTypes = {
  isNoPresencial: PropTypes.bool,
  setModulos: PropTypes.func,
  markModulosDirty: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modulos: PropTypes.array,
  sumatorio: PropTypes.number,
  sumatorioSuelto: PropTypes.number,
  sumatorio2: PropTypes.number,
  sumatorioSuelto2: PropTypes.number,
  idMatricula: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  estado: PropTypes.bool,
  activity: PropTypes.object,
  setActivity: PropTypes.func,
  hoursCounter: PropTypes.number,
  setHoursCounter: PropTypes.func,
  ccodcli: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  allFirstYearChecked: PropTypes.bool,
  allSecondYearChecked: PropTypes.bool,
  setPrecioFinal: PropTypes.func,
};

export default ActividadesGrupos;
